var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "_fc_struct" },
    [
      _c(
        "ElButton",
        {
          staticStyle: { width: "100%" },
          on: {
            click: function ($event) {
              _vm.visible = true
            },
          },
        },
        [_vm._v(_vm._s(_vm.title))]
      ),
      _vm._v(" "),
      _c(
        "ElDialog",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.visible,
            "close-on-click-modal": false,
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _vm.visible ? _c("div", { ref: "editor" }) : _vm._e(),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _vm.err
                ? _c(
                    "span",
                    {
                      staticStyle: {
                        color: "red",
                        float: "left",
                        "text-align": "left",
                      },
                    },
                    [
                      _vm._v(
                        "\n        输入内容格式有误" +
                          _vm._s(_vm.err !== true ? _vm.err : "") +
                          "\n      "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "ElButton",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.visible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "ElButton",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.onOk },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }